/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type CurrentContractBaseSolutionHorizonType =
  (typeof CurrentContractBaseSolutionHorizonType)[keyof typeof CurrentContractBaseSolutionHorizonType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CurrentContractBaseSolutionHorizonType = {
  short_term: "short_term",
  mid_term: "mid_term",
  long_term: "long_term",
} as const;
